import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import FormControl from '@mui/material/FormControl'
import Typography from '@mui/material/Typography'

import AutocompleteSelect from 'cityads-v3/components/AutocompleteSelect/AutocompleteSelect'
import { Region } from 'cityads-v3/types/offers'
import { FormFields } from './AdvertisingMarkingForm.hooks'

type Step1Props = {
  countries: Region[],
  country: FormFields['country'],
  countryRegion: Region | null,
}

export default function Step1({ countries, country, countryRegion }: Step1Props): JSX.Element {
  const { t } = useTranslation(['Publisher'])

  const getCountryLabel = useCallback((region: Region) => region.name, [])
  const handleCountryChange = useCallback((region: Region) => {
    country.handleValueChange(region.id)
  }, [country.handleValueChange])

  return (
    <>
      <Typography component="p">
        {t('advertisingMarking.form.p1')}
      </Typography>
      <Typography component="p">
        {t('advertisingMarking.form.p2')}
      </Typography>
      <Typography component="p">
        {t('advertisingMarking.form.p3')}
      </Typography>
      <ul>
        <Typography component="li">
          {t('advertisingMarking.form.li1')}
        </Typography>
        <Typography component="li">
          {t('advertisingMarking.form.li2')}
        </Typography>
      </ul>
      <Typography component="p">
        {t('advertisingMarking.form.p4')}
      </Typography>
      <Typography>
        {t('advertisingMarking.form.p5')}
      </Typography>
      <FormControl variant="standard" margin="normal" fullWidth required>
        <AutocompleteSelect
          suggestions={countries as any}
          label={t('advertisingMarking.form.country')}
          helperText={country.error}
          error={!!country.error}
          value={countryRegion as any}
          onChange={handleCountryChange as any}
          getOptionLabel={getCountryLabel as any}
          id={'country'}
          autoFocus
          fullWidth
        />
      </FormControl>
    </>
  )
}
